import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  height: 150px;
  max-width: 550px;

  right: 20px;
  bottom: 110px; // fix
  background-color: black;
  border-radius: 12px;
  padding: 15px;
  display: flex;
  gap: 12px;

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    width: 100vw;
    max-width: unset;
    right: 0;
  }
  
  & > div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`

export const Cover = styled.div`
  width: 212px;
  min-width: 212px;

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    width: 50%;
    height: auto;
    min-width: unset;
  }

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: 8px;
  }

`

export const Header = styled.p`
  font-size: ${({ theme }) => theme.old.fonts.size.small};
  margin-bottom: 5px;
`

export const Title = styled.p`
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: fit-content;
`